/* @generated */

// src/assets/ui-icon/line/briefcase.tsx
import * as React from "react";
var BriefcaseLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 16.75h4v-1.5h-4v1.5Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7.144v-.75a2.25 2.25 0 0 1 2.25-2.25h3.5A2.25 2.25 0 0 1 16 6.394v.75h3.75v4.25c0 .78-.397 1.468-1 1.871v6.59H5.25v-6.59c-.603-.403-1-1.09-1-1.87v-4.25H8Zm1.5-.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v.75h-5v-.75Zm-3.75 5v-2.75h12.5v2.75a.75.75 0 0 1-.75.75h-11a.75.75 0 0 1-.75-.75Zm1 2.25v4.712h10.5v-4.712H6.75Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  BriefcaseLine
};
